module.exports = __webpack_public_path__ + "static/media/tq10.900add83.jpg";